import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { DenseLayoutComponent } from './dense.component';
@NgModule({
  imports: [DenseLayoutComponent],
  exports: [DenseLayoutComponent],
  providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class DenseLayoutModule {}
